import axiosInstance from "../utils/axiosInstance";
import { Deal } from "../interfaces/deal.interface";

interface PagedDeals {
  deals: Deal[];
  totalPages: number;
  totalCount: number;
}

class ExclusiveDealsApi {

  getDeals(page: number = 1): Promise<PagedDeals> {
    const apiUrl = "/b2c2b/api/v1/brand_exclusive_deals";

    return axiosInstance.get(apiUrl, { params: { page } })
    .then(response => {
      const deals: Deal[] = response.data.data.map(({ id, attributes }) => {
        const deal: Deal = {
          id: Number(id),
          headline: attributes.highlight,
          title: attributes.title,
          subtitle: attributes.subtitle,
          cta: "View Product",
          redirectUrl: attributes.redirect_url,
        };
        return deal;
      });
      return Promise.resolve({
        deals,
        totalPages: response.data.meta.total_pages,
        totalCount: response.data.meta.total_count,
      });
    });
  }

}

export default ExclusiveDealsApi;
